import { API_BASE_URL, getApiOrigin, resolvePublicFileUrl } from "../constants/api-urls";

export function resolveHubAuctionImage(path, auctionId) {
  if (!path) return "";
  const s = String(path).trim();
  if (/^https?:\/\//i.test(s) || s.startsWith("data:")) return s;
  const baseUrl = getApiOrigin();
  if (s.startsWith("/auction-media/")) return `${baseUrl}${s}`;
  const fileName = s.split(/[/\\]/).pop();
  if (fileName && auctionId) return `${baseUrl}/auction-media/${auctionId}/${fileName}`;
  return resolvePublicFileUrl(s);
}

export function resolveHubImage(path) {
  return resolvePublicFileUrl(path);
}

export function getUserDisplayName(user) {
  if (!user || typeof user !== "object") return "Guest";
  const raw = user.name ?? user.user_name ?? user.full_name ?? user.company_name;
  if (typeof raw === "string" && raw.trim()) return raw.trim();
  const email = user.email;
  if (typeof email === "string" && email.includes("@")) return email.split("@")[0].trim();
  return "User";
}

export function getUserRoleLabel(user) {
  if (!user) return "Visitor";
  const typeId = String(user.user_type_id ?? "").trim();
  if (typeId.includes("1")) return "Buyer";
  if (typeId.includes("2") || typeId.includes("3")) return "Seller";
  if (typeId.includes("4")) return "Quality Inspector";
  return "Business User";
}

/** user_type_id 2 = Seller, 3 = Both (buyer + seller) */
export function isSellerUser(user) {
  if (!user) return false;
  let userTypeId = user.user_type_id;
  if (userTypeId === null || userTypeId === undefined) userTypeId = "";
  else userTypeId = String(userTypeId).trim();
  const typeIds = userTypeId
    ? userTypeId.split(",").map((id) => String(id).trim()).filter((id) => id && id !== "null" && id !== "undefined")
    : [];
  const singleId = parseInt(userTypeId, 10);
  return (
    (!Number.isNaN(singleId) && userTypeId.indexOf(",") === -1 && (singleId === 2 || singleId === 3)) ||
    typeIds.some((id) => {
      const numId = parseInt(id, 10);
      return id === "2" || id === "3" || numId === 2 || numId === 3;
    })
  );
}

export const HUB_API_BASE = API_BASE_URL;
